import { useAppLayout } from '@context/LayoutContext';
import { Spin } from 'antd';
import { SpinIndicator } from 'antd/lib/spin';
import classNames from 'classnames';

import s from './index.module.less';

type LoadingContainerProps = {
  size?: 'small' | 'default' | 'large';
  className?: string;
  indicator?: SpinIndicator;
};

export default function LoadingContainer({ size: sizeProp, className, indicator }: LoadingContainerProps) {
  const { isMobile } = useAppLayout();
  const size = isMobile ? 'small' : sizeProp || 'default';

  return (
    <div className={classNames(className, s.root)}>
      <Spin size={size} indicator={indicator} />
    </div>
  );
}
